import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

let Kyc_notlist = () => {
  let [data, setData] = useState();


  let navigate = useNavigate();
  let [value, inputvalue] = useState(false);
  const [text, setText] = useState("");
  const [refdata, setRefdata] = useState();
  const [refdatas, setRefdatas] = useState();
  const [counts, setCountdata] = useState();
  let [indexs, setIndex] = useState(1);
  let [count, setCount] = useState();

  let [indexss, setIndexs] = useState(1);
  const [refercounts, setReferCountdata] = useState();

  const [refdatareal, setRefdatareal] = useState();

  useEffect(() => {
    Start();
    RewardDeath()
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };


  let RewardDeath = async () => {
    inputvalue(true)

    try {
      let token = await localStorage.getItem("token");

      let pp = {
        token, page: 1, limit: 10, panpage: 1,
        limitpan: 10, aadharlimit: 10, aadharpage: 1
      };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "admin2/kycnotverify",
        data: pp,
      })
        .then((dat) => {
          inputvalue(false)
          console.log(dat.data.data)
          setRefdata(dat.data.data)
          setCount(dat.data.totalCount);
        })
        .catch((ee) => {
          inputvalue(false)
        });
    } catch (err) { }
  };


  const handlePageClick = async (event) => {

    console.log(event.selected + 1, "state");
    setCountdata(event.selected);

    inputvalue(true)

    try {
      let token = await localStorage.getItem("token");

      let pp = {
        token, page: event.selected + 1, limit: 10, panpage: 1,
        limitpan: 10, aadharlimit: 10, aadharpage: 1
      };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "admin2/kycnotverify",
        data: pp,
      })
        .then((dat) => {
          inputvalue(false)
          setRefdata(dat.data.data)
          // setCount(dat.data.totalCount);
        })
        .catch((ee) => {
          inputvalue(false)
        });
    } catch (err) { }
  };


  function convertToIndianDate(utcDateString) {
    const date = new Date(utcDateString);

    // Convert to IST (UTC+5:30)
    const istOffset = 5.5 * 60; // minutes
    const istDate = new Date(date.getTime() + istOffset * 60 * 1000);

    const day = String(istDate.getDate()).padStart(2, '0');
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const year = istDate.getFullYear();

    return `${day}-${month}-${year}`;
  }



  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        >
          <p style={{ fontWeight: '700', fontSize: 20 }} >KYC not Verify</p>


          <Tabs>
            <TabList>
              <Tab>Merchant</Tab>
              <Tab>Aadhar</Tab>

              <Tab>Pan</Tab>
            </TabList>

            <TabPanel>

              <div className="row mb-5 mt-3" style={{ border: '1px solid rgb(216, 216, 216)' }}  >
                <div className="col-2" >
                  <p>IFSC</p>
                </div>
                <div className="col-2" >
                  <p>Account No</p>
                </div>
                <div className="col-2" >
                  <p>User Account Name</p>
                </div>
                <div className="col-2" >
                  <p>User Account Phone</p>
                </div>
                <div className="col-2" >
                  <p>Date</p>
                </div>

              </div>




              <div className="position-relative" style={{ width: '100%' }}>

                {
                  refdata?.map((re, index) => {
                    return (
                      <div className="row" style={{ border: '1px solid rgb(216, 216, 216)' }}  >
                        <div className="col-2" >
                          <p>{re?.ifsc}</p>
                        </div>
                        <div className="col-2" >
                          <p>{re?.account_No}</p>
                        </div>
                        <div className="col-2" >
                          <p>{re?.userDetails?.name}</p>
                        </div>
                        <div className="col-2" >
                          <p>{re?.userDetails?.phoneno}</p>
                        </div>
                        <div className="col-2" >
                          <p>{convertToIndianDate(re?.createdAt)}</p>
                        </div>
                      </div>
                    );
                  })
                }



                {
                  value === true ?
                    <div className="position-relative mt-5" style={{ width: '100%' }}>Loading..</div> :

                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="next >"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      pageCount={count / 10}
                      previousLabel="< previous"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination justify-content-center"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      activeClassName="active"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      forcePage={counts}
                    />
                }




              </div>
            </TabPanel>
            <TabPanel>



              <p>Current Holiday list</p>




            </TabPanel>

            <TabPanel>



              <p>Current Holiday pan</p>




            </TabPanel>

          </Tabs>

        </div>
      </div>
    </div>
  );
};

export default Kyc_notlist;
